import { render, staticRenderFns } from "./BuyMemberModal.vue?vue&type=template&id=0bb27778&scoped=true"
import script from "./BuyMemberModal.vue?vue&type=script&lang=js"
export * from "./BuyMemberModal.vue?vue&type=script&lang=js"
import style0 from "./BuyMemberModal.vue?vue&type=style&index=0&id=0bb27778&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb27778",
  null
  
)

export default component.exports